import { useCallback, useState } from 'react';

/**
 * トグル機能を提供するカスタムフック
 *
 * @param {boolean} [initialState=false] - 初期状態
 * @returns {[boolean, () => void]} トグル状態とトグル関数のペア
 */
export const useToggle = (initialState = false): [boolean, () => void] => {
  const [state, setState] = useState(initialState);
  const toggle = useCallback(() => setState((current) => !current), []);

  return [state, toggle];
};
